// extracted by mini-css-extract-plugin
export default {"container":"Index_container__ST-8S"};